import Button from '@components/_elements/Button/Button';
import React from 'react';

interface DataPointSearchButtonProps {
  onClick: () => void;
}

const DataPointSearchButton: React.FC<DataPointSearchButtonProps> = ({
  onClick,
}) => (
  <div
    className='label no-pd-top'
    style={{ position: 'absolute', bottom: 0, left: 10 }}
  >
    <Button size='m' classType='container-bg' onClick={onClick}>
      Datapoint Search
    </Button>
  </div>
);

export default DataPointSearchButton;
